const craftPosts = [
    {
        id: 0,
        title: 'Flask - Getting started',
        thumbnail: 'assets/images/craftthumbs/flask.jpg',
        link: 'https://www.craft.do/s/wdTTdgwrGbcXD9',
        desc: 'Get started with flask with this series of tutorials that I created while learning flask myself! These contain, overly simplied notes and steps to create your very first flask project.',
        date: '2020-03-17T15:00+05:30'
    },
    {
        id: 1,
        title: 'Dub Dub 20 - Inception',
        thumbnail: 'assets/images/craftthumbs/wwdc20.jpg',
        link: 'https://www.craft.do/s/2UTkkJMOS8uvPa',
        desc: 'My debut project for Apple\'s World Wide Developer\'s conferece! It is based on the covid-19 pandemic that we faced throughout the year 2020 and built using XCode and Swift.',
        date: '2020-06-21T15:00+05:30'
    },
    {
        id: 2,
        title: 'Dub Dub 21 - Journey Continues',
        thumbnail: 'assets/images/craftthumbs/wwdc21.png',
        link: 'https://www.craft.do/s/R46d0FylXfXBuw',
        desc: 'My Second attempt at Apple\'s World Wide Developer\'s conferece! I have made use of AR and other jolly features to make yet another Swift Playground, but this time, with a SwiftUI Base.',
        date: '2021-04-04T15:00+05:30'
    },
    {
        id: 3,
        title: 'Frontend Hacks',
        thumbnail: 'assets/images/craftthumbs/tools.jpg',
        link: 'https://www.craft.do/s/NEBDZmmImKGWGe',
        desc: 'Here are some useful tools and hacks that you might possibly need while architecting frontends of the web. They have been pretty handy to me and can help you overcome a few everyday caveats.',
        date: '2020-05-14T15:00+05:30'
    },
    {
        id: 4,
        title: 'Cascasding Style Sheets',
        thumbnail: 'assets/images/craftthumbs/css.jpg',
        link: 'https://www.craft.do/s/wlKsV0zMPSFwvP',
        desc: 'I have finally begun to learn CSS *properly* ! Here\'s the resources I\'ve been using to learn CSS, it basically comprises of a tutorial from web.dev combined with the CSS Podcast.',
        date: '2021-05-19T15:00+05:30'
    },
    {
        id: 5,
        title: 'Full text search in MySQL',
        thumbnail: 'assets/images/craftthumbs/mysql.png',
        link: 'https://typesense.org/learn/full-text-search-mysql/',
        desc: 'While MySQL is not a fully featured text search engine, it has enough tricks up its sleeve to be useful for implementing basic search features in your application. Let’s take a quick walk through.',
        date: '2021-06-21T15:00+05:30'
    },
    {
        id: 6,
        title: 'Fuzzy Search with Javascript',
        thumbnail: 'assets/images/craftthumbs/fuse.png',
        link: 'https://typesense.org/learn/fuzzy-search-javascript/',
        desc: 'Fuzzy Search refers to the process of approximately searching for a given search query. It may also be called as a “typo tolerant search”. Let\'s see how we can implement fuzzy search using JS',
        date: '2021-06-10T15:00+05:30'
    },

]

export default craftPosts.reverse();